import html from "../assets/html.png";
import css from "../assets/css.png";
import tailwind from "../assets/tailwind.png";
import javascript from "../assets/javascript.png";
import node from "../assets/node.png";
import reactImage from "../assets/react.png";
import graphql from "../assets/graphql.png";
import nextjs from "../assets/nextjs.png";
import nuxtjs from "../assets/portfolio/nuxt-logo.svg";
import github from "../assets/github.png";

const stacks = [
  {
    id: 1,
    src: html,
    name: "HTML",
    style: "shadow-orange-500",
  },
  {
    id: 2,
    src: css,
    name: "CSS",
    style: "shadow-blue-500",
  },
  {
    id: 3,
    src: tailwind,
    name: "Tailwind CSS",
    style: "shadow-sky-500",
  },
  {
    id: 4,
    src: javascript,
    name: "Javascript",
    style: "shadow-yellow-500",
  },
  {
    id: 5,
    src: node,
    name: "Node",
    style: "shadow-green-500",
  },
  {
    id: 6,
    src: reactImage,
    name: "React",
    style: "shadow-blue-600",
  },
  {
    id: 7,
    src: graphql,
    name: "GraphQL",
    style: "shadow-pink-500",
  },
  {
    id: 8,
    src: nextjs,
    name: "NextJS",
    style: "shadow-white",
  },
  {
    id: 9,
    src: nuxtjs,
    name: "Nuxt",
    style: "shadow-white",
  },
  {
    id: 10,
    src: github,
    name: "GitHub",
    style: "shadow-gray-500",
  },
];

const Experience = () => {
  return (
    <div
      name="Experience"
      className="w-full bg-gradient-to-b from-gray-800 to-black text-white md:h-screen"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            Experience
          </p>
          <p className="py-6">Below are the technologies i have worked with</p>
        </div>

        <div className="w-full text-center grid sm:grid-cols-2 md:grid-cols-3 gap-8 px-12 sm:px-0">
          {stacks.map(({ id, src, name, style }) => (
            <div
              key={id}
              className={`shadow-md hover:scale-105 shadow-gray-600 rounded-lg ${style}`}
            >
              <img src={src} alt="pic" className="w-20 mx-auto" />
              <p className="mt-4">{name}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Experience;
